import type { ChecklistSectionInDto } from 'shared/dtos/in/template';
import {
  HttpRequestEntity,
  HttpRequestModelType,
} from 'shared/domain/httpRequest/httpRequestModel';
import {
  broadcastChecklistSectionOperationError,
  broadcastCreatedChecklistSection,
  broadcastUpdatedChecklistSection,
  broadcastDeletedChecklistSection,
  broadcastReorderedChecklistSection,
  broadcastDeletedChecklistSectionDocument,
} from 'serviceWorker/broadcasts/checklistSections';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { inspectionTemplateSource } from 'serviceWorker/services/inspectionTemplates/inspectionTemplateSource';
import { responseErrorOf } from './responseError';

export function broadcastChecklistSectionResponse(
  request: HttpRequestEntity,
  response: unknown
): void {
  const error = responseErrorOf(response);
  if (error) {
    return broadcastChecklistSectionOperationError(error, request.data?.uniqueId, chooseErrorMessage(error));
  }
  // Sections, items and answers are stored inside their template: sync it.
  inspectionTemplateSource.sync();
  // The server's answer once it carries no error.
  const section = response as ChecklistSectionInDto;

  if (request.entityType === HttpRequestModelType.checklistSectionDocument) {
    return broadcastDeletedChecklistSectionDocument(
      response,
      request.data.uniqueId
    );
  }

  if (request.method === 'POST') {
    return broadcastCreatedChecklistSection(section, request.data.uniqueId);
  }

  if (request.method === 'PUT') {
    if (request.url.includes('/reorder')) {
      return broadcastReorderedChecklistSection(response, request.data.uniqueId);
    }
    return broadcastUpdatedChecklistSection(response, request.data.uniqueId);
  }

  if (request.method === 'DELETE') {
    return broadcastDeletedChecklistSection(response, request.data.uniqueId);
  }
}
